// Generated by purs version 0.13.0
"use strict";
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var isVisibleTile = function (v) {
    return function (pos) {
        return Data_Map_Internal.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(v.visible);
    };
};
var isSeenTile = function (v) {
    return function (pos) {
        return Data_Set.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(v.seen);
    };
};
var initFovMask = {
    visible: Data_Map_Internal.empty,
    seen: Data_Set.empty
};
module.exports = {
    initFovMask: initFovMask,
    isVisibleTile: isVisibleTile,
    isSeenTile: isSeenTile
};
